import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const Sv = () => {
  const { t } = useTranslation();

  return (
    <Box display="flex">
      <Box mr={1}>
        <img
          src="https://flagcdn.com/16x12/se.png"
          srcset="https://flagcdn.com/32x24/se.png 2x,
https://flagcdn.com/48x36/se.png 3x"
          width="16"
          height="12"
          alt="Svenska"
        />
      </Box>
      <Typography>{t(`language.sv`)}</Typography>
    </Box>
  );
};

export default Sv;
